import React, { Component } from 'react';
import Toolbar from "../Toolbar/Toolbar";
import SideDrawer from "../SideDrawer/SideDrawer";
import Posts from '../Posts/Posts'
class Layout extends Component {
    state = {
        showSideDrawer: false
    }
    showSideDrawer = () => {
        this.setState((prev) => {
            prev.showSideDrawer = true;
            return prev;
        })
    }

    hideSideDrawer = () => {
        this.setState((prev) => {
            prev.showSideDrawer = false;
            return prev;
        })
    }

    render() {
        return (
            <div >
                <Toolbar showSideDrawer={this.showSideDrawer} />
                <SideDrawer show={this.state.showSideDrawer} clicked={this.hideSideDrawer} />
                <main>
                    <Posts />
                </main>
            </div>);
    }
}

export default Layout;